export const EMANDATE = "EMANDATE"
export const EMANDATE_RESPONSE = 'EMANDATE_RESPONSE'
export const EMANDATE_RESPONSE_FAIL = 'EMANDATE_RESPONSE_FAIL'